import type { UseAppForm } from '../../form';
import type { HeaderField } from './HeaderField/HeaderField';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../lib/helpers';

import Button from '../../../components/Button/Button';

import { useFieldContext, useFormContext } from '../../form';

interface HeadersFieldProps {
  /**
   * If field is disabled
   */
  disabled?: boolean;
  /**
   * Component test ID
   */
  testId?: string;
}

const HeadersField = ({ disabled, testId }: HeadersFieldProps) => {
  const { t } = useTranslation();
  const field = useFieldContext<HeaderField[]>();
  const form = useFormContext() as unknown as UseAppForm;

  const removeValue = useCallback(
    (idx: number) => {
      field.removeValue(idx);
      field.handleBlur();
    },
    [field],
  );

  const addValue = useCallback(() => {
    field.pushValue({ header_name: '', header_value: '' });
    field.handleBlur();
  }, [field]);

  return (
    <div {...getTestProps(testId, `container`)}>
      {field.state.value?.map((_, index) => (
        <form.AppField key={index} name={`headers[${index}]`}>
          {(field) => (
            <field.HeaderField
              onRemove={removeValue}
              index={index}
              disabled={disabled}
              testId={testId}
            />
          )}
        </form.AppField>
      ))}

      <Button
        additionalClasses="w-max mb-4"
        additionalChildrenClasses="flex flex-row items-center"
        onClick={addValue}
        disabled={disabled}
        {...getTestProps(testId, `button-add`, 'testId')}
      >
        {t('Webhooks.AddHeader')}
      </Button>
    </div>
  );
};
export default HeadersField;
